var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2091 21.9309L21.2274 15.5369C19.581 17.9341 17.0104 19.6411 14.0348 20.1587L16.5308 25.5111C16.8499 26.196 17.8375 26.1503 18.0945 25.443L19.3738 21.9288L19.6375 21.8058L23.1518 23.0852C23.857 23.3439 24.5278 22.6131 24.2091 21.9309ZM12.1454 0C7.007 0 2.82618 4.18057 2.82618 9.31917C2.82618 14.4578 7.00706 18.6383 12.1454 18.6383C17.2837 18.6383 21.4645 14.4578 21.4645 9.31917C21.4645 4.18057 17.2838 0 12.1454 0ZM16.6798 8.63444L15.0273 10.2453L15.4179 12.5205C15.5372 13.2152 14.8053 13.737 14.1884 13.4135L12.1454 12.3396L10.1024 13.4135C9.48193 13.7393 8.75423 13.2113 8.87296 12.5205L9.26347 10.2453L7.611 8.63439C7.10877 8.14476 7.38751 7.29006 8.08047 7.18936L10.3645 6.8576L11.386 4.78811C11.6951 4.15965 12.5955 4.15909 12.905 4.78811L13.9265 6.8576L16.2105 7.18936C16.9034 7.29 17.182 8.14476 16.6798 8.63444ZM3.06338 15.5369L0.0817103 21.9309C-0.238466 22.6163 0.438347 23.3431 1.13903 23.085L4.65329 21.8057L4.91695 21.9286L6.19628 25.4429C6.45278 26.1487 7.44022 26.1974 7.75999 25.5111L10.256 20.1587C7.28036 19.6411 4.70981 17.9342 3.06338 15.5369Z",
    fill: "#0F0C0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertified);
export default __webpack_public_path__ + "static/media/Certified.e69dcf492aef2624fb981b6c656f1e87.svg";
export { ForwardRef as ReactComponent };